var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeatureDocumentClassification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 162.001,
    height: 205.75,
    viewBox: "0 0 162.001 205.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1133",
    "data-name": "Group 1133",
    transform: "translate(-648.999 -800)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "streamline-icon-accounting-document_64x64",
    "data-name": "streamline-icon-accounting-document@64x64",
    transform: "translate(740 800)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_742",
    "data-name": "Path 742",
    d: "M58,58a4,4,0,0,1-4,4H10a4,4,0,0,1-4-4V6a4,4,0,0,1,4-4H38.344A4,4,0,0,1,41.17,3.17L56.829,18.829A4,4,0,0,1,58,21.656Z",
    fill: "none",
    stroke: "#00b7bc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_743",
    "data-name": "Path 743",
    d: "M58,22H42a4,4,0,0,1-4-4V2",
    fill: "none",
    stroke: "#00b7bc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_744",
    "data-name": "Path 744",
    d: "M16.533,30.917a5.931,5.931,0,0,0,4.955,2.333c3.037,0,5.5-1.848,5.5-4.125S24.533,25,21.5,25,16,23.155,16,20.875s2.464-4.125,5.5-4.125a5.923,5.923,0,0,1,4.955,2.333",
    fill: "none",
    stroke: "#00b7bc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_745",
    "data-name": "Path 745",
    d: "M21.5,33.251V36",
    fill: "none",
    stroke: "#00b7bc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_746",
    "data-name": "Path 746",
    d: "M21.5,14v2.749",
    fill: "none",
    stroke: "#00b7bc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_747",
    "data-name": "Path 747",
    d: "M32,40H48",
    fill: "none",
    stroke: "#00b7bc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_748",
    "data-name": "Path 748",
    d: "M18,52H48",
    fill: "none",
    stroke: "#00b7bc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("g", {
    id: "streamline-icon-accounting-bills_64x64",
    "data-name": "streamline-icon-accounting-bills@64x64",
    transform: "translate(747 876)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_749",
    "data-name": "Path 749",
    d: "M11,20a1,1,0,1,1-1,1,1,1,0,0,1,1-1",
    fill: "none",
    stroke: "#00b7bc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_750",
    "data-name": "Path 750",
    d: "M45,34a1,1,0,1,1-1,1,1,1,0,0,1,1-1",
    fill: "none",
    stroke: "#00b7bc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_482",
    "data-name": "Rectangle 482",
    width: 52,
    height: 32,
    rx: 4,
    transform: "translate(2 12)",
    fill: "none",
    stroke: "#00b7bc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_39",
    "data-name": "Ellipse 39",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(20 20)",
    fill: "none",
    stroke: "#00b7bc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_751",
    "data-name": "Path 751",
    d: "M62,24V48a4,4,0,0,1-4,4H14",
    fill: "none",
    stroke: "#00b7bc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("g", {
    id: "streamline-icon-basketball-ball_64x64",
    "data-name": "streamline-icon-basketball-ball@64x64",
    transform: "translate(747 945)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_752",
    "data-name": "Path 752",
    d: "M2,30A28,28,0,1,0,30,2,28,28,0,0,0,2,30Z",
    fill: "none",
    stroke: "#00b7bc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_753",
    "data-name": "Path 753",
    d: "M10.064,49.752c3.412-10.346,13.851-32.831,41.131-38",
    transform: "translate(-0.538 -0.65)",
    fill: "none",
    stroke: "#00b7bc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_754",
    "data-name": "Path 754",
    d: "M9.6,12.053c11.16,4.064,32.037,15.132,36.415,41.963",
    transform: "translate(-0.507 -0.67)",
    fill: "none",
    stroke: "#00b7bc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_755",
    "data-name": "Path 755",
    d: "M26.377,2.256A20.7,20.7,0,0,1,2.76,23.72",
    transform: "translate(-0.051 -0.017)",
    fill: "none",
    stroke: "#00b7bc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_756",
    "data-name": "Path 756",
    d: "M31.21,59.726C19.587,41.085,41.362,19.71,59.725,31.211",
    transform: "translate(-1.73 -1.731)",
    fill: "none",
    stroke: "#00b7bc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("g", {
    id: "streamline-icon-performance-tablet-increase_64x64",
    "data-name": "streamline-icon-performance-tablet-increase@64x64",
    transform: "translate(648.973 873.138)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_757",
    "data-name": "Path 757",
    d: "M62,55.96,58.027,50V36c0-5.333-10.133-11.04-14-14",
    fill: "none",
    stroke: "#5f5cd7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_758",
    "data-name": "Path 758",
    d: "M49.173,39.448l-9.728-7.795a3.475,3.475,0,0,0-4.915,4.915L43.952,47.2v6.667c0,3.149,4.5,8.12,4.5,8.12",
    fill: "none",
    stroke: "#5f5cd7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_759",
    "data-name": "Path 759",
    d: "M36.027,58H5.691a3.667,3.667,0,0,1-3.664-3.667V5.664A3.664,3.664,0,0,1,5.691,2H40.357a3.667,3.667,0,0,1,3.669,3.664V35.325",
    fill: "none",
    stroke: "#5f5cd7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_760",
    "data-name": "Path 760",
    d: "M26.027,10h8v8",
    fill: "none",
    stroke: "#5f5cd7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_761",
    "data-name": "Path 761",
    d: "M34.027,10l-24,22",
    fill: "none",
    stroke: "#5f5cd7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_762",
    "data-name": "Path 762",
    d: "M14,42v8",
    fill: "none",
    stroke: "#5f5cd7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_763",
    "data-name": "Path 763",
    d: "M22,36V50",
    fill: "none",
    stroke: "#5f5cd7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_764",
    "data-name": "Path 764",
    d: "M18025.777,867.139v-7.673h61.375V842.8",
    transform: "translate(-128.238 19003.777) rotate(-90)",
    fill: "none",
    stroke: "#c4c4c4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_765",
    "data-name": "Path 765",
    d: "M0,0V7.672H61.375V24.342",
    transform: "translate(738.9 832) rotate(90)",
    fill: "none",
    stroke: "#c4c4c4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_766",
    "data-name": "Path 766",
    d: "M18087.152,867.234V842.8",
    transform: "translate(-128.238 18992.283) rotate(-90)",
    fill: "none",
    stroke: "#c4c4c4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureDocumentClassification);
export default __webpack_public_path__ + "static/media/feature-document-classification.9023fe29.svg";
export { ForwardRef as ReactComponent };